/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Pricing page components
import FaqCollapse from "layouts/pages/pricing-page/components/FaqCollapse";

function Faq() {
  const [collapse, setCollapse] = useState(false);

  return (
    <SoftBox mt={16}>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={6}>
          <SoftTypography variant="h2" align="center" fontWeight="bold" gutterBottom>
            Frequently Asked Questions
          </SoftTypography>
          {/* <SoftBox mb={2}>
            <SoftTypography variant="body2" align="center" color="text">
              A lot of people don&apos;t appreciate the moment until it’s passed. I&apos;m not
              trying my hardest, and I&apos;m not trying to do
            </SoftTypography>
          </SoftBox> */}
        </Grid>
        <Grid item xs={12} md={10}>
          <FaqCollapse
            title="What results can I expect from a subscription?"
            open={collapse === 1}
            onClick={() => (collapse === 1 ? setCollapse(false) : setCollapse(1))}
          >
            As a DIY investment research platform, we provide no guarantee of future returns. However, subscribers that use our platform constantly outperformed market indices around the world.
          </FaqCollapse>
          <FaqCollapse
            title="What if i am a complete new beginner? Would i be completely lost?"
            open={collapse === 2}
            onClick={() => (collapse === 2 ? setCollapse(false) : setCollapse(2))}
          >
            There are learning guides in the application to guide you through all the steps regarding stocks and options. And if you still feel that you require additional help, we have a free 3 hours stocks and options course.
          </FaqCollapse>
          <FaqCollapse
            title="Where does your data come from?"
            open={collapse === 3}
            onClick={() => (collapse === 3 ? setCollapse(false) : setCollapse(3))}
          >
            Our fundamental, price history and estimates is sourced from EOD historical data.
          </FaqCollapse>
          <FaqCollapse
            title="Can i use the BullBearVector app on my phone or desktop?"
            open={collapse === 4}
            onClick={() => (collapse === 4 ? setCollapse(false) : setCollapse(4))}
          >
            Yes. BullBearVector is designed for both mobile and desktop.
            <br />
          </FaqCollapse>
          <FaqCollapse
            title="What is GEM Ranks?"
            open={collapse === 5}
            onClick={() => (collapse === 5 ? setCollapse(false) : setCollapse(5))}
          >
            GEM Ranking is a automated ranking system, backed by accurate data, based on investment gurus such as Warren Buffett, Joel Greenblatt, Ray Dailo and many others…
          </FaqCollapse>
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default Faq;
